import type { Subproject } from '../../../../api/projects-client/projects-client.type';
import type { BoardTableRow } from './projects.type';

/**
 * Maps a board to a table row
 *
 * @param {Subproject} board The board to map to a table row
 * @returns {BoardTableRow} The table row for the board
 */
function mapBoardToTableRow(board: Subproject): BoardTableRow {
  return {
    id: board.id,
    name: board.name,
    configurationState: board.configuration_state || 'N/A',
  };
}

export { mapBoardToTableRow };
